import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Kebab } from '../../icons';
import { useDevice } from '../Device';
import { Divider } from '../Divider';
import { DropdownMenu } from '../DropdownMenu';
import { FullPageModalHeaderEnd } from '../FullPageModal';
import { IconButton } from '../IconButton';
import { TextButton } from '../TextButton';
import styles from './FullPageModalAdditionalActions.module.scss';
import { FullPageModalAdditionalActionsTestIds } from './FullPageModalAdditionalActions.utils';
export function FullPageModalAdditionalActions(props) {
    const { isMobileDevice } = useDevice();
    const inlineActions = isMobileDevice ? [] : props.inlineActions;
    const dropdownActions = isMobileDevice ? props.inlineActions.concat(props.dropdownActions) : props.dropdownActions;
    const hasDropdownActions = dropdownActions.length > 0;
    return /*#__PURE__*/ _jsx(FullPageModalHeaderEnd, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.root, {
                [styles.mobile]: isMobileDevice
            }),
            "data-testid": props.testId,
            children: [
                inlineActions.map((action, idx)=>{
                    const { text, testId, disabled, skin, intent, tooltipTitle, iconStart, onClick, bi } = action;
                    const tooltip = tooltipTitle ? {
                        title: tooltipTitle
                    } : undefined;
                    const isLast = idx === inlineActions.length - 1;
                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(TextButton, {
                                underline: "none",
                                skin: skin || 'secondary',
                                intent: intent,
                                disabled: disabled,
                                prefixIcon: iconStart,
                                testId: testId,
                                tooltip: tooltip,
                                onClick: onClick,
                                bi: bi,
                                children: text
                            }),
                            (!isLast || hasDropdownActions) && /*#__PURE__*/ _jsx(Divider, {
                                orientation: "vertical",
                                margin: 12,
                                size: 24
                            })
                        ]
                    }, text);
                }),
                hasDropdownActions && /*#__PURE__*/ _jsx(DropdownMenu, {
                    testId: FullPageModalAdditionalActionsTestIds.DropdownMenu(),
                    vAlign: "bottom",
                    target: /*#__PURE__*/ _jsx(IconButton, {
                        skin: "transparent",
                        noPadding: true,
                        size: "small",
                        testId: FullPageModalAdditionalActionsTestIds.MoreButton(),
                        children: /*#__PURE__*/ _jsx(Kebab, {})
                    }),
                    children: dropdownActions.map((action)=>{
                        const { text, testId, disabled, skin, intent, iconStart, onClick, tooltipTitle, bi } = action;
                        const tooltip = tooltipTitle ? {
                            title: /*#__PURE__*/ _jsx("div", {
                                "data-testid": testId && "".concat(testId, "-tooltip"),
                                children: tooltipTitle
                            })
                        } : undefined;
                        return /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                            skin: skin,
                            intent: intent,
                            disabled: disabled,
                            testId: testId,
                            iconStart: /*#__PURE__*/ _jsx("div", {
                                className: styles.actionIcon,
                                children: iconStart
                            }),
                            onClick: onClick,
                            tooltipProps: tooltip,
                            bi: bi,
                            children: text
                        }, text);
                    })
                })
            ]
        })
    });
}
